/*
  This list of countries originated from the list of targetable countries
  in Tako. If you find yourself updating the list below, you might want
  also want to update the one in Send Service:
  https://github.com/change/comms_send_service/blob/1fb7a5bd7aeea85955b81c2ec002e322e6ad46ea/lib/comms_send_service/query_builder/filters/country_filter.ex#L20-L90


  TODO: update the sendServiceAvailableFilters query in graphql to retrieve this list of countries
*/
export const countryCodeList = [
	'AR',
	'AT',
	'AU',
	'BE',
	'BG',
	'BO',
	'BR',
	'BW',
	'BY',
	'CA',
	'CH',
	'CL',
	'CO',
	'CR',
	'CU',
	'CY',
	'CZ',
	'DE',
	'DK',
	'DO',
	'EC',
	'EG',
	'ES',
	'ET',
	'FI',
	'FJ',
	'FO',
	'FR',
	'GB',
	'GE',
	'GH',
	'GR',
	'GT',
	'HK',
	'HN',
	'HU',
	'ID',
	'IE',
	'IL',
	'IN',
	'IR',
	'IS',
	'IT',
	'JP',
	'KE',
	'KR',
	'LB',
	'LI',
	'LK',
	'LT',
	'LU',
	'LV',
	'LY',
	'MA',
	'MT',
	'MX',
	'MY',
	'NG',
	'NI',
	'NL',
	'NO',
	'NP',
	'NZ',
	'PA',
	'PE',
	'PH',
	'PK',
	'PL',
	'PR',
	'PT',
	'PY',
	'RO',
	'RU',
	'RW',
	'SA',
	'SE',
	'SG',
	'SV',
	'SZ',
	'TH',
	'TR',
	'TW',
	'TZ',
	'UA',
	'UG',
	'US',
	'UY',
	'VE',
	'ZA',
	'ZM',
	'ZW',
];
